module.exports = __webpack_public_path__ + "img/ion-marin.5d254b82.png";